import React, { Fragment, useRef, useState, useEffect } from 'react';
import Topbar from './Topbar';
import { useNavigate } from 'react-router-dom';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import { Helmet } from 'react-helmet';
import { Dialog, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import instantSupportDialogIcon from '../../assets/images/instantSupportDialogIcon.svg';
import { getPathForInstantSupport, successToast, errorToast } from '../../utils/helper';
// import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
// import { is } from 'date-fns/locale';

import { CompanyApi } from '../../api/companyApi';
import Loader from '../../component/common/Loader';

const UpgradePlansPage = () => {
  const { companyId } = JSON.parse(localStorage.getItem('userData')); // userType
  // const [open, setOpen] = useState(false);
  const [employeeCount, setEmployeeCount] = useState(0); // 3 numberOfEmployees
  const [selectedPlan, setSelectedPlan] = useState(''); // 1 selectedPlan
  const cancelButtonRef = useRef(null);
  const [loader, setLoader] = useState(true); // Set this to true initially while loading data
  const [isAnnual, setIsAnnual] = useState(true); // 4 billingType
  const [openPlan, setOpenPlan] = useState(''); // 2 same as selectedPlan
  const [upgradeUserPaymentDialogOpen, setupgradeUserPaymentDialogOpen] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false); // New state to track if data has been loaded
  const [currentBillingTypeAnnual, setcurrentBillingTypeAnnual] = useState(true);
  const [typeOfPayment, setTypeOfPayment] = useState();
  const [upgradedPlan, setupgradedPlan] = useState('');
  const navigate = useNavigate();

  const planNamesToPlanIDs = {
    telephonic: '0',
    face: '1',
    rise: '2'
  };

  const planIDs = {
    0: 'telephonic', // Telephonic EAP
    1: 'face', // Face to Face & Video Services EAP
    2: 'rise' // Shoorah RISE Plan
  };

  const plans = {
    telephonic: {
      title: 'Telephonic EAP',
      price: 1.10,
      priceAnnually: 14.5,
      planRequirements: [
        '24/7, 365 telephone counselling and advice line',
        'Up to 6 structured counselling sessions per issue per year',
        'In-the-moment support between counselling sessions',
        'Personal financial/debt support through Auriga',
        'Legal advice through Irwin Mitchell',
        'Critical incident advice and telephone support',
        'Support for those with care responsibilities'
      ]
    },
    face: {
      title: 'Face to Face & Video Services EAP', // Face to Face & Video Services EAP
      price: 1.35,
      priceAnnually: 23.0,
      planRequirements: [
        'Includes all Telephonic EAP benefits',
        'Access to telephone, virtual, or face-to-face counselling',
        '10% discount on our B2B Premium plan'
      ]
    },
    rise: {
      title: 'Shoorah RISE Plan', // Shoorah RISE Plan
      price: 2.75,
      priceAnnually: 46.0,
      planRequirements: [
        'Includes all Face-to-Face & Video Services EAP benefits',
        'Enhanced psychological assessments, complex case support, CBT, and EMDR therapy',
        'Access to enhanced psychological assessments, complex case support and complex case management when deemed clinically appropriate. This includes CBT and EMDR therapy.',
        'Full case management for maximised clinical outcomes',
        '24/7, 365 health and wellbeing advice',
        'Online GP consultation services',
        'Full Premium access to our App and B2B suite'
      ]
    }
  };

  // useEffect to properly fetch and set the data
  useEffect(() => {
    // Show loader while fetching data
    setLoader(true);

    CompanyApi.getInstantSupportCompanyStatus(companyId)
      .then((response) => {
        if (response?.status === 200) {
          console.log('response from getInstantSupportCompanyStatus', response);
          const {
            billingType,
            numberOfEmployees,
            selectedPlan: selectedPlan_,
            type
          } = response?.data;
          console.log(
            'billingType :',
            billingType,
            '\n numberOfEmployees:',
            numberOfEmployees,
            '\n selectedPlan',
            selectedPlan_,
            '\n Type of user 1=Custom 2=payOnInvoice',
            type
          );

          // Update all the states at once
          setTypeOfPayment(type);
          setEmployeeCount(numberOfEmployees === 99999 ? 0 : numberOfEmployees);
          setSelectedPlan(planIDs[selectedPlan_]);
          setOpenPlan(planIDs[selectedPlan_]);
          setIsAnnual(billingType === 'yearly' || billingType === 'Yearly' ? true : false);
          setcurrentBillingTypeAnnual(
            billingType === 'yearly' || billingType === 'Yearly' ? true : false
          );
          setDataLoaded(true); // Mark data as loaded
        }
      })
      .catch((error) => {
        console.error('Error fetching company status:', error);
        setDataLoaded(true);
      })
      .finally(() => {
        // Hide loader when done, regardless of success or failure
        setLoader(false);
      });
  }, [companyId]);

  const handleUpgradePlans = () => {
    //console.log("selectedPlan in the options & EMP COUNT", selectedPlan, employeeCount);
    const upgradePlansDetails = {
      companyID: companyId,
      planId: parseInt(planNamesToPlanIDs[upgradedPlan]),
      type: typeOfPayment,
      upgradeType: 2,
      billingType: isAnnual ? 'yearly' : 'monthly'
    };
    console.log('payload for upgrade plans ', upgradePlansDetails);

    setLoader(true); // Show loader while processing

    CompanyApi.postUpdateUserAndInstantsupportPlan(upgradePlansDetails)
      .then((response) => {
        //console.log("response from upgrade plan LINK", response.data.paymentLink);
        if (response?.status === 200) {
          // const paymentLink = response?.data?.data?.paymentLink;
          // console.log('postInstantSupportUpgradeUsers paymentLink:', paymentLink);

          // if (paymentLink) {
          //   window.open(paymentLink, '_blank');
          // }
          if (response?.data?.meta?.code === 1) {
            console.log('Message from Upgrade Plans API :', response?.data?.meta?.message);
            successToast(response?.data?.meta?.message);
          }
          setupgradeUserPaymentDialogOpen(true);
        } else {
          errorToast('Failed to upgrade users');
        }
      })
      .catch((error) => {
        console.log('Error while upgrading the plan', error);
        errorToast('Error while upgrading the plan');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const toggleRequirements = (plan) => {
    setOpenPlan(openPlan === plan ? null : plan);
  };

  const telephonicLabelRef = useRef(null);
  const faceLabelRef = useRef(null);
  const riseLabelRef = useRef(null);


  useEffect(() => {
    if (selectedPlan === "telephonic" && telephonicLabelRef.current) {
      telephonicLabelRef.current.click();
    } else if (selectedPlan === "face" && faceLabelRef.current) {
      faceLabelRef.current.click();
    } else if(selectedPlan === "rise" && riseLabelRef.current){
      riseLabelRef.current.click();
    }
  }, [selectedPlan]);

  return (
    <>
      <div className="relative lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>B2B | Get Support</title>
        </Helmet>
        {loader ? <Loader /> : null}
        <Topbar title={'Instant Support (EAP)'} infoBtn={false} />

        <div className="flex flex-col w-full max-w-4xl bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
          {/* <div className="flex items-center justify-start mb-8">
            
          </div> */}
          <div className="flex items-center justify-start mb-8">
            <div
              className="relative flex bg-white dark:bg-shoorah-badgeText border-gray-300 border rounded-full w-40 p-1 sm:w-48 md:w-56 lg:w-80 cursor-pointer"
              onClick={() => setIsAnnual(!isAnnual)}
            >
              {/* Toggle Background */}
              <div
                className={`absolute top-1 bottom-1 w-[48.5%] bg-black dark:bg-shoorah-inputBackground rounded-full transition-all ${
                  isAnnual ? 'translate-x-0' : 'translate-x-full'
                }`}
              ></div>

              {/* Text Container */}
              <div className="relative text-xs py-2 z-10 flex w-full">
                {/* Annually Text */}
                <div className="w-1/2 flex items-center justify-center">
                  <span
                    className={`transition-colors ${
                      isAnnual ? 'text-white dark:text-black' : 'text-black dark:text-white'
                    }`}
                  >
                    Annually
                  </span>
                </div>

                {/* Monthly Text */}
                <div className="w-1/2 flex items-center justify-center">
                  <span
                    className={`transition-colors ${
                      !isAnnual ? 'text-white dark:text-black' : 'text-black dark:text-white'
                    }`}
                  >
                    Monthly
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col mb-2 sm:flex-row justify-between">
            <p className="text-xl font-medium  text-gray-900 dark:text-white">
              Select an add-on plan
            </p>
            <a
              href="mailto:info@shoorah.io"
              className="btn-primary btn-sm sm:mt-0 w-auto h-auto"
            >
              Speak to Sales?
            </a>
          </div>

          {/* selected plan info */}
          {/* {'selected Plane :' +
            selectedPlan +
            '\t Upgrade Plan:' +
            upgradedPlan +
            '\t isAnnual:' +
            isAnnual +
            '\t currentBillingTypeAnnual:' +
            currentBillingTypeAnnual} */}

          {/* mark */}
          <>
            {typeOfPayment === 1 ? (
              <>
                {/* for custom number */}
                <div className="w-full mx-auto mt-2 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                  {/* Employee Count Input */}
                  <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-shoorah-darkBorder flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-3">
                    <label className="text-gray-700 dark:text-gray-300 font-medium text-sm text-left sm:text-left">
                      How many employees do you wish to add to this plan?
                    </label>

                    <div className="p-2 border text-center border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-gray-200 bg-white dark:bg-gray-800 w-full sm:w-16 h-9">
                      <input
                        type="number"
                        // min=""
                        placeholder="00"
                        value={employeeCount}
                        onChange={(e) => setEmployeeCount(parseInt(e.target.value))}
                        className="w-full h-full text-center bg-transparent outline-none"
                      />
                    </div>
                  </div>

                  <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                    <div>
                      <label
                        key={'one'}
                        className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                        onClick={() => {
                          toggleRequirements('telephonic');
                          setOpenPlan('telephonic');
                          setupgradedPlan('telephonic');
                        }}
                      >
                        <div className="flex items-center w-full sm:w-auto">
                          <input
                            type="radio"
                            name="plan"
                            className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                            checked={upgradedPlan === 'telephonic'}
                            onChange={() => setupgradedPlan('telephonic')}
                          />
                          <span className="text-base font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                            {plans.telephonic.title}
                          </span>
                        </div>
                        <div className="flex-1 text-left sm:text-right">
                          <div className="text-gray-900 font-semibold  dark:text-gray-400 text-sm sm:text-xl">
                            <span className="text-lg sm:text-2xl ">£</span>
                            {isAnnual
                              ? plans.telephonic.priceAnnually
                              : plans.telephonic.price.toFixed(2)}{' '}
                            +VAT <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                          </div>
                        </div>
                      </label>

                      <div className="h-[0.5px] mx-5 bg-gray-200"></div>

                      {/* Requirements Dropdown */}
                      <div
                        className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                        onClick={() => toggleRequirements('telephonic')}
                      >
                        <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                          Requirements
                        </span>
                        <button>
                          {openPlan === 'telephonic' ? (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </button>
                      </div>

                      {openPlan === 'telephonic' && (
                        <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                          {plans.telephonic.planRequirements.map((text, index) => (
                            <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                              <img
                                src={instantSupportTick}
                                alt="DropdownIcon"
                                className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                              />
                              <span className="text-[#606060] dark:text-gray-300">{text}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* face to face */}
                <div className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                  <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                    <div>
                      <label
                        className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                        onClick={() => {
                          toggleRequirements('face');
                          setOpenPlan('face');
                          setupgradedPlan('face');
                        }}
                      >
                        <div className="flex items-center w-full sm:w-auto">
                          <input
                            type="radio"
                            name="plan"
                            className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                            checked={upgradedPlan === 'face'}
                            onChange={() => setupgradedPlan('face')}
                          />
                          <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                            {plans.face.title}
                          </span>
                        </div>
                        <div className="flex-1 text-left sm:text-right">
                          <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                            <span className="text-lg sm:text-2xl ">£</span>
                            {isAnnual
                              ? plans.face.priceAnnually
                              : plans.face.price.toFixed(2)} +VAT{' '}
                            <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                          </div>
                        </div>
                      </label>

                      <div className="h-[0.5px] mx-5 bg-gray-200"></div>

                      <div
                        className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                        onClick={() => toggleRequirements('face')}
                      >
                        <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                          Requirements
                        </span>
                        <button>
                          {openPlan === 'face' ? (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </button>
                      </div>

                      {openPlan === 'face' && (
                        <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                          {plans.face.planRequirements.map((text, index) => (
                            <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                              <img
                                src={instantSupportTick}
                                alt="DropdownIcon"
                                className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                              />
                              <span className="text-[#606060] dark:text-gray-300">{text}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* rise plan */}

                <div className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                  <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                    <div>
                      <label
                        className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                        onClick={() => {
                          toggleRequirements('rise');
                          setOpenPlan('rise');
                          setupgradedPlan('rise');
                        }}
                      >
                        <div className="flex items-center w-full sm:w-auto">
                          <input
                            type="radio"
                            name="plan"
                            className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                            checked={upgradedPlan === 'rise'}
                            onChange={() => setupgradedPlan('rise')}
                          />
                          <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                            {plans.rise.title}
                          </span>
                        </div>
                        <div className="flex-1 text-left sm:text-right">
                          <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                            <span className="text-lg sm:text-2xl ">£</span>
                            {isAnnual
                              ? plans.rise.priceAnnually
                              : plans.rise.price.toFixed(2)} +VAT{' '}
                            <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                          </div>
                        </div>
                      </label>

                      <div className="h-[0.5px] mx-5 bg-gray-200"></div>

                      <div
                        className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                        onClick={() => toggleRequirements('rise')}
                      >
                        <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                          Requirements
                        </span>
                        <button>
                          {openPlan === 'rise' ? (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </button>
                      </div>

                      {openPlan === 'rise' && (
                        <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                          {plans.rise.planRequirements.map((text, index) => (
                            <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                              <img
                                src={instantSupportTick}
                                alt="DropdownIcon"
                                className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                              />
                              <span className="text-[#606060] dark:text-gray-300">{text}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* for strip & payonInvoice */}
                <div className="w-full mx-auto mt-2 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                  {/* Employee Count Input */}
                  <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-shoorah-darkBorder flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-3">
                    <label className="text-gray-700 dark:text-gray-300 font-medium text-sm text-left sm:text-left">
                      How many employees do you wish to add to this plan?
                    </label>
                    <div className="p-2 border text-center border-gray-300  dark:border-gray-600 rounded-lg text-gray-900 dark:text-gray-200 bg-white dark:bg-gray-800 w-full sm:w-16 h-9">
                      {employeeCount} {/* Display the actual employee count from state */}
                    </div>
                  </div>

                  <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                    <div>
                      <label
                        ref={telephonicLabelRef}
                        key={'one'}
                        className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                        onClick={() => {
                          toggleRequirements('telephonic');
                          setOpenPlan('telephonic');
                          setupgradedPlan('telephonic');
                        }}
                      >
                        <div className="flex items-center w-full sm:w-auto">
                          <input
                            type="radio"
                            name="plan"
                            className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                            checked={upgradedPlan === 'telephonic'}
                            disabled={
                              selectedPlan === 'telephonic' && isAnnual === currentBillingTypeAnnual
                            }
                            onChange={() => setupgradedPlan('telephonic')}
                          />

                          <span className="text-base font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                            {plans['telephonic']?.title || 'Select a plan'}
                          </span>
                        </div>
                        <div className="flex-1 text-left sm:text-right">
                          <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                            <span className="text-lg sm:text-2xl ">£</span>
                            {isAnnual
                              ? plans['telephonic']?.priceAnnually
                              : plans['telephonic']?.price.toFixed(2)}{' '}
                            +VAT <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                          </div>
                        </div>
                      </label>

                      <div className="h-[0.5px] mx-5 bg-gray-200"></div>

                      {/* Requirements Dropdown */}
                      <div
                        className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                        onClick={() => toggleRequirements('telephonic')}
                      >
                        <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                          Requirements
                        </span>
                        <button>
                          {openPlan === 'telephonic' ? (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                            >
                              <path
                                d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                stroke="#0B0B0B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </button>
                      </div>

                      {openPlan === 'telephonic' && plans['telephonic']?.planRequirements && (
                        <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                          {plans['telephonic'].planRequirements.map((text, index) => (
                            <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                              <img
                                src={instantSupportTick}
                                alt="DropdownIcon"
                                className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                              />
                              <span className="text-[#606060] dark:text-gray-300">{text}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* face to face */}
                {selectedPlan ? (
                  <>
                    <div className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                      <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                        <div>
                          <label
                            ref={faceLabelRef}
                            className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                            onClick={() => {
                              toggleRequirements('face');
                              setOpenPlan('face');
                              setupgradedPlan('face');
                            }}
                          >
                            <div className="flex items-center w-full sm:w-auto">
                              <input
                                type="radio"
                                name="plan"
                                className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                                checked={upgradedPlan === 'face'}
                                disabled={
                                  selectedPlan === 'face' && isAnnual === currentBillingTypeAnnual
                                }
                                onChange={() => setupgradedPlan('face')}
                              />
                              <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                                {plans?.face?.title}
                              </span>
                            </div>
                            <div className="flex-1 text-left sm:text-right">
                              <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                <span className="text-lg sm:text-2xl ">£</span>
                                {isAnnual
                                  ? plans?.face?.priceAnnually
                                  : plans?.face?.price.toFixed(2)}{' '}
                                +VAT{' '}
                                <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                              </div>
                            </div>
                          </label>

                          <div className="h-[0.5px] mx-5 bg-gray-200"></div>

                          <div
                            className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                            onClick={() => toggleRequirements('face')}
                          >
                            <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                              Requirements
                            </span>
                            <button>
                              {openPlan === 'face' ? (
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                                >
                                  <path
                                    d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                    stroke="#0B0B0B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                                >
                                  <path
                                    d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                    stroke="#0B0B0B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </button>
                          </div>

                          {openPlan === 'face' && (
                            <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                              {plans?.face?.planRequirements.map((text, index) => (
                                <div
                                  key={index}
                                  className="flex items-start my-3 text-xs sm:text-sm"
                                >
                                  <img
                                    src={instantSupportTick}
                                    alt="DropdownIcon"
                                    className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                                  />
                                  <span className="text-[#606060] dark:text-gray-300">{text}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}

                {/* rise plan */}
                {selectedPlan ? (
                  <>
                    <div className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                      <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                        <div>
                          <label
                            ref={riseLabelRef}
                            className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                            onClick={() => {
                              toggleRequirements('rise');
                              setOpenPlan('rise');
                              setupgradedPlan('rise');
                            }}
                          >
                            <div className="flex items-center w-full sm:w-auto">
                              <input
                                type="radio"
                                name="plan"
                                className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                                checked={upgradedPlan === 'rise'}
                                disabled={
                                  selectedPlan === 'rise' && isAnnual === currentBillingTypeAnnual
                                }
                                onChange={() => setupgradedPlan('rise')}
                              />
                              <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                                {plans?.rise?.title}
                              </span>
                            </div>
                            <div className="flex-1 text-left sm:text-right">
                              <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                <span className="text-lg sm:text-2xl ">£</span>
                                {isAnnual
                                  ? plans?.rise?.priceAnnually
                                  : plans?.rise?.price.toFixed(2)}{' '}
                                +VAT{' '}
                                <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                              </div>
                            </div>
                          </label>

                          <div className="h-[0.5px] mx-5 bg-gray-200"></div>

                          <div
                            className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                            onClick={() => toggleRequirements('rise')}
                          >
                            <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                              Requirements
                            </span>
                            <button>
                              {openPlan === 'rise' ? (
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                                >
                                  <path
                                    d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                    stroke="#0B0B0B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                                >
                                  <path
                                    d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                                    stroke="#0B0B0B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </button>
                          </div>

                          {openPlan === 'rise' && (
                            <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                              {plans?.rise?.planRequirements.map((text, index) => (
                                <div
                                  key={index}
                                  className="flex items-start my-3 text-xs sm:text-sm"
                                >
                                  <img
                                    src={instantSupportTick}
                                    alt="DropdownIcon"
                                    className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                                  />
                                  <span className="text-[#606060] dark:text-gray-300">{text}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
          </>
          {/* mark */}

          <button
            onClick={() => handleUpgradePlans()}
            className="btn-primary"
            disabled={selectedPlan === upgradedPlan && isAnnual === currentBillingTypeAnnual}
          >
            Upgrade plan
          </button>
        </div>

        {/* UI ENDS HERE  Dialoge BOX here now*/}
        <Transition.Root show={upgradeUserPaymentDialogOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            initialFocus={cancelButtonRef}
            onClose={setupgradeUserPaymentDialogOpen}
          >
            {/* Disable interactions with the background when modal is open */}
            <div
              className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity"
              inert={upgradeUserPaymentDialogOpen ? 'true' : undefined}
            />
            <div className="fixed inset-0 z-50 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                  <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                    <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                      <Dialog.Title
                        as="h3"
                        className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                      >
                        <img
                          src={instantSupportDialogIcon}
                          alt="DropdownIcon"
                          className="dark:invert mx-auto"
                        />
                      </Dialog.Title>
                    </div>
                    <div>
                      <p className="text-lg text-gray-700 dark:text-gray-300">
                        Thankyou for upgrading your instant support (EAP) plan, your plan changes
                        are being reviewed by Shoorah. You will be notified soon
                      </p>
                      <Link
                        className="w-[173px] h-[40px] bg-[#1F1F1F] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer shadow-sm flex items-center justify-center mx-auto mt-6"
                        onClick={() => {
                          setupgradeUserPaymentDialogOpen(false);
                          setTimeout(() => {
                            navigate(getPathForInstantSupport('/instant-support'));
                          }, 100);
                        }}
                      >
                        Got It
                      </Link>
                    </div>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </div>
    </>
  );
};

export default UpgradePlansPage;
